export default "__VITE_ASSET__DXBLYPk3__"